"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getExtensions = exports.createOasParamsIterator = void 0;
const utils_1 = require("../utils");
const guards_1 = require("./guards");
const types_1 = require("./types");
const ROOT_EXTENSIONS = ['x-internal'];
const getIdForParameter = (param) => `${param.name}-${param.in}`;
function createOasParamsIterator(spec) {
    return function* (path, operation) {
        const seenParams = new Set();
        const { parentId, context } = this;
        const opParams = Array.isArray(operation.parameters) ? operation.parameters : [];
        const params = [...opParams, ...(Array.isArray(path.parameters) ? path.parameters : [])];
        for (let i = 0; i < params.length; i++) {
            const param = this.maybeResolveLocalRef(params[i]);
            if (!(spec === types_1.OasVersion.OAS2 ? guards_1.isValidOas2Param : guards_1.isValidOas3Param)(param))
                continue;
            const key = getIdForParameter(param);
            if (seenParams.has(key))
                continue;
            seenParams.add(key);
            if (this.context !== 'service') {
                this.context = i < opParams.length ? 'operation' : 'path';
            }
            yield param;
        }
        this.context = context;
        this.parentId = parentId;
    };
}
exports.createOasParamsIterator = createOasParamsIterator;
function getExtensions(target) {
    return Object.fromEntries((0, utils_1.entries)(target).filter(([key]) => key.startsWith('x-') && !ROOT_EXTENSIONS.includes(key)));
}
exports.getExtensions = getExtensions;
//# sourceMappingURL=accessors.js.map